import { Box, Typography } from '@mui/material';
import { PARTNER_BRAND } from '../../partnerDashboardTheme';
import { getReplyAuthorName, getReplyPreviewText } from '../communityChatReply';

/**
 * Quoted parent preview inside a chat bubble (mobile ConversationScreen replyContext).
 */
const CommunityReplyContext = ({
  parentMessage,
  isOutbound = false,
  currentUserIds,
  compact = false,
}) => {
  if (!parentMessage) {
    return null;
  }

  const authorName = getReplyAuthorName(parentMessage, { currentUserIds });
  const previewText = getReplyPreviewText(parentMessage);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        alignSelf: 'stretch',
        mb: compact ? 0.75 : 1,
        py: compact ? 0.625 : 0.75,
        pr: 1.25,
        borderRadius: '10px',
        overflow: 'hidden',
        minWidth: 140,
        bgcolor: isOutbound ? 'rgba(255, 255, 255, 0.2)' : 'rgba(17, 24, 39, 0.05)',
        border: '1px solid',
        borderColor: isOutbound ? 'rgba(255, 255, 255, 0.14)' : 'rgba(17, 24, 39, 0.06)',
      }}
    >
      <Box
        sx={{
          width: 3,
          flexShrink: 0,
          bgcolor: isOutbound ? '#FFFFFF' : PARTNER_BRAND,
          borderTopLeftRadius: '10px',
          borderBottomLeftRadius: '10px',
          mr: 1,
        }}
      />
      <Box sx={{ flex: 1, minWidth: 0, displayContent: 'center' }}>
        <Typography
          noWrap
          sx={{
            fontSize: compact ? '0.6875rem' : '0.75rem',
            fontWeight: 700,
            lineHeight: 1.35,
            mb: 0.25,
            color: isOutbound ? '#FFFFFF' : PARTNER_BRAND,
          }}
        >
          {authorName}
        </Typography>
        <Typography
          sx={{
            fontSize: compact ? '0.6875rem' : '0.75rem',
            fontWeight: 500,
            lineHeight: 1.35,
            color: isOutbound ? 'rgba(255, 255, 255, 0.88)' : 'text.secondary',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {previewText}
        </Typography>
      </Box>
    </Box>
  );
};

export default CommunityReplyContext;
